// client/src/neetjee_guru/components/libraryManagement/ReturnBook.jsx
import React, { Component } from "react";
import { Form, Button, Row, Col, Card, Modal, Alert, Spinner, Badge, Table, ListGroup } from "react-bootstrap";
import * as Cookies from "es-cookie";
import { GET_NEW_EDUCATIONAL_STUDENTS, GET_EMPLOYEES, GET_STUDENT_ACTIVE_LOANS } from "./queries";
import { RETURN_BOOK, RENEW_LOAN } from "./mutations";

class ReturnBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      borrowerType: (props.selectedBorrower && props.selectedBorrower.type === "Employee") ? "Employee" : "Student",
      allStudents: [],
      allEmployees: [],
      filteredBorrowers: [],
      
      studentQuery: props.selectedBorrower ? props.selectedBorrower.name : "",
      loadingStudents: false,
      
      // Single Return modal state
      showReturnModal: false,
      selectedLoan: null,
      paidAmount: 0.0,
      copyStatusOnReturn: "available", // available, lost, damaged
      customFineType: "LATE_RETURN", // LATE_RETURN, LOST_BOOK, DAMAGED_BOOK
      customFineAmount: 0.0,
      
      // Batch Return state
      selectedLoans: [],
      showBatchModal: false,
      batchReturnsData: {}, // key by loanId -> { status, customFineType, customFineAmount, paid_amount }

      returning: false,
      returnSuccess: null,
      returnError: null,
      renewSuccess: null,
      renewError: null,
    };
  }

  componentDidMount() {
    this.loadBorrowers();
  }

  loadBorrowers = async () => {
    const { client } = this.props;
    const instId = parseInt(Cookies.get("institute_id") || Cookies.get("institutionid") || "0");
    const branchId = parseInt(Cookies.get("branch_id") || Cookies.get("branchid") || "0");

    this.setState({ loadingStudents: true, returnError: null });

    let studentsList = [];
    try {
      const studentsData = await client.query({
        query: GET_NEW_EDUCATIONAL_STUDENTS,
        variables: { institution_id: instId, branch_id: String(branchId) },
        fetchPolicy: "cache-first",
      });
      // Filter out UNION rows where edu_student_id = NULL (online-only student_users with no edu_students row)
      // parseInt(null) = NaN — these have no valid borrower_id and must never appear in search results
      studentsList = (studentsData.data.getNewEducationalStudents || [])
        .filter(s => s.student_id != null && !isNaN(parseInt(s.student_id)))
        .map(s => ({
          id: parseInt(s.student_id),
          name: s.student_name || "(No name)",
          roll_no: s.roll_no || "",
          admission_no: s.admission_no || "",
          code: s.admission_no || s.roll_no || String(s.student_id),
          details: `Class: ${s.class_name || ""} (${s.section_name || ""}) | Adm No: ${s.admission_no || ""}`,
          type: "Student",
        }));
    } catch (err) {
      console.warn("getNewEducationalStudents query failed, falling back to dummy students:", err);
    }

    if (studentsList.length === 0) {
      studentsList = [
        { id: 101, name: "Aravind Swamy", roll_no: "CSE-23-01", admission_no: "ADM-2023-0101", code: "ADM-2023-0101", details: "Class: B.Tech III Yr (A) | Adm No: ADM-2023-0101", type: "Student" },
        { id: 102, name: "Priyanka Reddy", roll_no: "CSE-23-02", admission_no: "ADM-2023-0102", code: "ADM-2023-0102", details: "Class: B.Tech III Yr (A) | Adm No: ADM-2023-0102", type: "Student" },
        { id: 103, name: "Amit Sharma", roll_no: "ECE-23-45", admission_no: "ADM-2023-0103", code: "ADM-2023-0103", details: "Class: B.Tech III Yr (B) | Adm No: ADM-2023-0103", type: "Student" }
      ];
    }

    let employeesList = [];
    try {
      const employeesData = await client.query({
        query: GET_EMPLOYEES,
        variables: { institute_id: instId, branch_id: branchId },
        fetchPolicy: "cache-first",
      });
      employeesList = (employeesData.data.getEmployees || [])
        .filter(e => e.employee_id != null && !isNaN(parseInt(e.employee_id)))
        .map(e => ({
          id: parseInt(e.employee_id),
          name: e.employee_name || "(No name)",
          code: String(e.employee_id),
          details: `Employee ID: ${e.employee_id}`,
          type: "Employee",
        }));
    } catch (err) {
      console.warn("getEmployees query failed, falling back to dummy employees:", err);
    }

    if (employeesList.length === 0) {
      employeesList = [
        { id: 701, name: "Prof. Suresh R.", code: "201", details: "Department: Computer Science", type: "Employee" },
        { id: 702, name: "Dr. Anjali Patil", code: "202", details: "Department: Mathematics", type: "Employee" }
      ];
    }

    this.setState({
      allStudents: studentsList,
      allEmployees: employeesList,
      loadingStudents: false,
    }, this.searchStudents);
  };

  handleFieldChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      if (name === "studentQuery") {
        this.searchStudents();
      }
      if (name === "copyStatusOnReturn") {
        const { selectedLoan } = this.state;
        if (value === "lost" && selectedLoan) {
          this.setState({ customFineType: "LOST_BOOK", customFineAmount: 350.0 });
        } else if (value === "damaged" && selectedLoan) {
          this.setState({ customFineType: "DAMAGED_BOOK", customFineAmount: 150.0 });
        } else {
          this.setState({ customFineType: "LATE_RETURN", customFineAmount: selectedLoan ? selectedLoan.fine_amount : 0.0 });
        }
      }
    });
  };

  handleNumberChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: parseFloat(value) || 0.0 });
  };

  searchStudents = () => {
    const { studentQuery, borrowerType, allStudents, allEmployees } = this.state;
    if (!studentQuery || !studentQuery.trim()) {
      this.setState({ filteredBorrowers: [] });
      return;
    }

    const list = borrowerType === "Student" ? allStudents : allEmployees;
    const query = studentQuery.toLowerCase().trim();
    const filtered = list.filter(b => {
      // Guard: skip any entry with a missing name to prevent toLowerCase crash
      if (!b.name) return false;
      if (b.type === "Student") {
        return (
          b.name.toLowerCase().includes(query) ||
          (b.roll_no && b.roll_no.toLowerCase().includes(query)) ||
          (b.admission_no && b.admission_no.toLowerCase().includes(query))
        );
      } else {
        return (
          b.name.toLowerCase().includes(query) ||
          (b.code && b.code.toLowerCase().includes(query))
        );
      }
    });
    this.setState({ filteredBorrowers: filtered });
  };

  selectStudent = (student) => {
    this.setState({ filteredBorrowers: [], studentQuery: student.name, borrowerType: student.type === "Employee" ? "Employee" : "Student", selectedLoans: [] });
    if (this.props.setSelectedBorrower) {
      this.props.setSelectedBorrower(student);
    }
  };

  toggleLoanSelection = (loan) => {
    const { selectedLoans } = this.state;
    const isSelected = selectedLoans.some(l => l.id === loan.id);
    if (isSelected) {
      this.setState({
        selectedLoans: selectedLoans.filter(l => l.id !== loan.id)
      });
    } else {
      this.setState({
        selectedLoans: [...selectedLoans, loan]
      });
    }
  };

  selectAllLoans = () => {
    const activeLoans = this.props.activeLoans || [];
    const { selectedLoans } = this.state;
    if (selectedLoans.length === activeLoans.length) {
      this.setState({ selectedLoans: [] });
    } else {
      this.setState({ selectedLoans: [...activeLoans] });
    }
  };

  openBatchReturnModal = () => {
    const { selectedLoans } = this.state;
    const batchReturnsData = {};
    selectedLoans.forEach(loan => {
      batchReturnsData[loan.id] = {
        id: loan.id,
        book_title: loan.book_title,
        accession_no: loan.accession_no,
        fine_amount: loan.fine_amount || 0.0,
        paid_amount: loan.fine_amount || 0.0,
        status: "available",
        customFineType: "LATE_RETURN",
        customFineAmount: loan.fine_amount || 0.0,
      };
    });
    this.setState({
      batchReturnsData,
      showBatchModal: true,
      returning: false,
      returnError: null,
    });
  };

  handleBatchConditionChange = (loanId, status) => {
    const { batchReturnsData, selectedLoans } = this.state;
    const data = { ...batchReturnsData[loanId] };
    data.status = status;
    if (status === "lost") {
      data.customFineType = "LOST_BOOK";
      data.customFineAmount = 350.0;
      data.paid_amount = 350.0;
    } else if (status === "damaged") {
      data.customFineType = "DAMAGED_BOOK";
      data.customFineAmount = 150.0;
      data.paid_amount = 150.0;
    } else {
      const originalLoan = selectedLoans.find(l => l.id === loanId);
      data.customFineType = "LATE_RETURN";
      data.customFineAmount = originalLoan.fine_amount || 0.0;
      data.paid_amount = originalLoan.fine_amount || 0.0;
    }
    this.setState({
      batchReturnsData: {
        ...batchReturnsData,
        [loanId]: data
      }
    });
  };

  handleBatchNumberChange = (loanId, fieldName, value) => {
    const { batchReturnsData } = this.state;
    const data = { ...batchReturnsData[loanId] };
    data[fieldName] = parseFloat(value) || 0.0;
    this.setState({
      batchReturnsData: {
        ...batchReturnsData,
        [loanId]: data
      }
    });
  };

  handleBatchReturnSubmit = async (e) => {
    e.preventDefault();
    const { batchReturnsData, selectedLoans } = this.state;
    const { client } = this.props;
    const instId = parseInt(Cookies.get("institute_id") || Cookies.get("institutionid") || "0");
    const branchId = parseInt(Cookies.get("branch_id") || Cookies.get("branchid") || "0");

    const todayStr = new Date().toLocaleDateString('en-CA');
    this.setState({ returning: true, returnError: null });

    try {
      const mutations = selectedLoans.map(loan => {
        const item = batchReturnsData[loan.id];
        return client.mutate({
          mutation: RETURN_BOOK,
          variables: {
            issue_id: parseInt(loan.id),
            paid_amount: parseFloat(item.paid_amount),
            fine_type: item.status === "available" && item.customFineAmount === 0 ? null : item.customFineType,
            fine_amount: parseFloat(item.customFineAmount),
            status: item.status,
            institute_id: instId,
            branch_id: branchId,
            return_date: todayStr
          }
        });
      });

      await Promise.all(mutations);

      this.setState({
        returning: false,
        showBatchModal: false,
        selectedLoans: [],
        returnSuccess: `Successfully returned ${selectedLoans.length} books and updated fine records.`
      });

      if (this.props.refreshLoans) {
        this.props.refreshLoans();
      }
      if (this.props.showToast) {
        this.props.showToast(`Returned ${selectedLoans.length} books successfully!`, "success");
      }
    } catch (err) {
      console.error("Error executing batch returns:", err);
      this.setState({ returning: false, returnError: err.message });
    }
  };

  openReturnModal = (loan) => {
    this.setState({
      showReturnModal: true,
      selectedLoan: loan,
      paidAmount: loan.fine_amount || 0.0,
      copyStatusOnReturn: "available",
      customFineType: "LATE_RETURN",
      customFineAmount: loan.fine_amount || 0.0,
      returnError: null,
    });
  };

  handleReturnSubmit = async (e) => {
    e.preventDefault();
    const { selectedLoan, paidAmount, copyStatusOnReturn, customFineType, customFineAmount } = this.state;
    if (!selectedLoan) return;

    const { client } = this.props;
    const instId = parseInt(Cookies.get("institute_id") || Cookies.get("institutionid") || "0");
    const branchId = parseInt(Cookies.get("branch_id") || Cookies.get("branchid") || "0");

    try {
      const todayStr = new Date().toLocaleDateString('en-CA');
      this.setState({ returning: true, returnError: null });
      await client.mutate({
        mutation: RETURN_BOOK,
        variables: {
          issue_id: parseInt(selectedLoan.id),
          paid_amount: parseFloat(paidAmount),
          fine_type: copyStatusOnReturn === "available" && customFineAmount === 0 ? null : customFineType,
          fine_amount: parseFloat(customFineAmount),
          status: copyStatusOnReturn,
          institute_id: instId,
          branch_id: branchId,
          return_date: todayStr
        },
      });

      this.setState({
        returning: false,
        showReturnModal: false,
        selectedLoan: null,
        selectedLoans: this.state.selectedLoans.filter(l => l.id !== selectedLoan.id),
        returnSuccess: `Book "${selectedLoan.book_title}" successfully returned!`,
      });

      if (this.props.refreshLoans) {
        this.props.refreshLoans();
      }
      if (this.props.showToast) {
        this.props.showToast(`Book "${selectedLoan.book_title}" returned successfully!`, "success");
      }
    } catch (err) {
      console.error("Error returning book copy:", err);
      this.setState({ returning: false, returnError: err.message });
    }
  };

  handleRenew = async (issueId) => {
    const { client } = this.props;
    const instId = parseInt(Cookies.get("institute_id") || Cookies.get("institutionid") || "0");
    const branchId = parseInt(Cookies.get("branch_id") || Cookies.get("branchid") || "0");

    this.setState({ renewError: null, renewSuccess: null });

    try {
      await client.mutate({
        mutation: RENEW_LOAN,
        variables: {
          issue_id: parseInt(issueId),
          institute_id: instId,
          branch_id: branchId,
        },
      });
      this.setState({ renewSuccess: "Loan successfully renewed! Due date extended." });
      if (this.props.refreshLoans) {
        this.props.refreshLoans();
      }
      if (this.props.showToast) {
        this.props.showToast("Loan successfully renewed! Due date extended.", "success");
      }
    } catch (err) {
      this.setState({ renewError: "Renewal failed: " + err.message });
    }
  };

  formatCurrency = (val) =>
    "₹" + parseFloat(val || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  render() {
    const {
      borrowerType,
      studentQuery,
      filteredBorrowers,
      showReturnModal,
      selectedLoan,
      paidAmount,
      copyStatusOnReturn,
      customFineType,
      customFineAmount,
      returning,
      returnSuccess,
      returnError,
      renewSuccess,
      renewError,

      selectedLoans,
      showBatchModal,
      batchReturnsData,
      loadingStudents,
    } = this.state;

    const selectedStudent = this.props.selectedBorrower;
    const activeLoans = this.props.activeLoans || [];
    const loadingLoans = this.props.loadingLoans || false;

    const totalBatchFines = selectedLoans.reduce((acc, loan) => acc + (loan.fine_amount || 0.0), 0.0);

    // Full screen centered layout if borrower not selected
    if (!selectedStudent) {
      return (
        <div className="pb-5">
          {returnError && <Alert variant="danger" className="mb-4">{returnError}</Alert>}
          {returnSuccess && (
            <Alert variant="success" className="mb-4 d-flex justify-content-between align-items-center" style={{ borderRadius: 8 }}>
              <div>
                <i className="fal fa-check-circle fa-lg mr-2" style={{ color: "#10b981", marginRight: 8 }} />
                <strong>Return Processed:</strong> {returnSuccess}
              </div>
              <Button size="sm" variant="outline-success" onClick={() => this.setState({ returnSuccess: null })} style={{ fontWeight: 700 }}>
                Dismiss
              </Button>
            </Alert>
          )}

          <Row className="justify-content-center">
            <Col md={7} lg={5}>
              <Card className="border-0 shadow-sm" style={{ borderRadius: 16, marginTop: "24px" }}>
                <Card.Header style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0", padding: "20px 24px" }}>
                  <h6 className="mb-0 text-center" style={{ fontWeight: 800, color: "#1e293b", fontSize: 15 }}>
                    Identify Patrons / Returners
                  </h6>
                </Card.Header>
                <Card.Body className="p-4">
                  <div className="d-flex mb-4" style={{ gap: 8 }}>
                    <Button
                      size="sm"
                      style={{
                        background: borrowerType === "Student" ? "#4f46e5" : "#f1f5f9",
                        border: "none",
                        color: borrowerType === "Student" ? "#fff" : "#475569",
                        fontWeight: 700,
                        padding: "10px 16px",
                        borderRadius: 8,
                        flex: 1
                      }}
                      onClick={() => {
                        // Synchronous clear only — allStudents/allEmployees are already loaded
                        // Calling loadBorrowers here causes async race conditions with stale results
                        this.setState({ borrowerType: "Student", studentQuery: "", filteredBorrowers: [], selectedLoans: [] });
                        if (this.props.setSelectedBorrower) {
                          this.props.setSelectedBorrower(null);
                        }
                      }}
                    >
                      <i className="fal fa-graduation-cap mr-2" style={{ marginRight: 6 }} /> Student
                    </Button>
                    <Button
                      size="sm"
                      style={{
                        background: borrowerType === "Employee" ? "#4f46e5" : "#f1f5f9",
                        border: "none",
                        color: borrowerType === "Employee" ? "#fff" : "#475569",
                        fontWeight: 700,
                        padding: "10px 16px",
                        borderRadius: 8,
                        flex: 1
                      }}
                      onClick={() => {
                        // Synchronous clear only — allStudents/allEmployees are already loaded
                        this.setState({ borrowerType: "Employee", studentQuery: "", filteredBorrowers: [], selectedLoans: [] });
                        if (this.props.setSelectedBorrower) {
                          this.props.setSelectedBorrower(null);
                        }
                      }}
                    >
                      <i className="fal fa-user-briefcase mr-2" style={{ marginRight: 6 }} /> Staff
                    </Button>
                  </div>

                  <Form.Group className="mb-4">
                    <Form.Label style={{ fontSize: 11, fontWeight: 800, color: "#64748b" }} className="text-uppercase">Search Borrower Name or Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="studentQuery"
                      value={studentQuery}
                      onChange={this.handleFieldChange}
                      placeholder="Type name, roll or admission code..."
                      style={{ height: 44, fontSize: 13, borderRadius: 8 }}
                      autoComplete="off"
                    />
                  </Form.Group>

                  {loadingStudents ? (
                    <div className="text-center py-4"><Spinner animation="border" size="sm" /></div>
                  ) : (
                    <ListGroup style={{ maxHeight: 250, overflowY: "auto" }}>
                      {filteredBorrowers.map((st) => (
                        <ListGroup.Item
                          key={st.id}
                          action
                          onClick={() => this.selectStudent(st)}
                          style={{ border: "1px solid #f1f5f9", borderRadius: 8, marginBottom: 8, padding: "12px 16px" }}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <div style={{ fontWeight: 700, color: "#1e293b", fontSize: 13 }}>{st.name}</div>
                            <small className="text-muted" style={{ fontSize: 11 }}>Code: {st.code}</small>
                          </div>
                          <Badge variant="primary" style={{ background: "#e0f2fe", color: "#0369a1", fontSize: 10, padding: "5px 8px" }}>Select</Badge>
                        </ListGroup.Item>
                      ))}
                      {filteredBorrowers.length === 0 && studentQuery.trim() && (
                        <div className="text-center py-4 text-muted" style={{ fontSize: 12 }}>No matching borrower profiles found.</div>
                      )}
                    </ListGroup>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      );
    }

    return (
      <div className="pb-5">
        {returnError && <Alert variant="danger" className="mb-4" dismissible onClose={() => this.setState({ returnError: null })}>{returnError}</Alert>}
        {renewError && <Alert variant="danger" className="mb-4" dismissible onClose={() => this.setState({ renewError: null })}><strong>Renewal Failed:</strong> {renewError}</Alert>}
        {returnSuccess && (
          <Alert variant="success" className="mb-4 d-flex justify-content-between align-items-center" style={{ borderRadius: 8 }}>
            <div>
              <i className="fal fa-check-circle fa-lg mr-2" style={{ color: "#10b981", marginRight: 8 }} />
              <strong>Return Processed:</strong> {returnSuccess}
            </div>
            <Button size="sm" variant="outline-success" onClick={() => this.setState({ returnSuccess: null })} style={{ fontWeight: 700 }}>
              Dismiss
            </Button>
          </Alert>
        )}
        {renewSuccess && (
          <Alert variant="info" className="mb-4 d-flex justify-content-between align-items-center" style={{ borderRadius: 8, background: "#eff6ff", border: "1px solid #bfdbfe" }}>
            <div style={{ color: "#1d4ed8" }}>
              <i className="fal fa-sync-alt mr-2" style={{ marginRight: 8 }} />
              <strong>Renewal Confirmed:</strong> {renewSuccess}
            </div>
            <Button size="sm" variant="outline-primary" onClick={() => this.setState({ renewSuccess: null })} style={{ fontWeight: 700 }}>
              Dismiss
            </Button>
          </Alert>
        )}

        <Row>
          {/* Side Panel: Selected Borrower Info */}
          <Col lg={3} className="mb-4">
            <Card className="border-0 shadow-sm" style={{ borderRadius: 12 }}>
              <Card.Header style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0", padding: "14px 18px" }} className="d-flex justify-content-between align-items-center">
                <h6 className="mb-0" style={{ fontWeight: 800, color: "#1e293b", fontSize: 13 }}>Patron Profile</h6>
                <Button 
                  variant="link" 
                  onClick={() => {
                    // Only clear local state keys that actually exist; selectedBorrower lives in props
                    this.setState({ studentQuery: "", selectedLoans: [], renewSuccess: null, renewError: null });
                    if (this.props.setSelectedBorrower) {
                      this.props.setSelectedBorrower(null);
                    }
                  }} 
                  style={{ color: "#ef4444", fontSize: 12, fontWeight: 700, padding: 0 }}
                >
                  Change
                </Button>
              </Card.Header>
              <Card.Body className="p-3">
                <div className="p-3 border rounded bg-light" style={{ borderRadius: 10 }}>
                  <small className="text-muted text-uppercase" style={{ fontSize: 9, fontWeight: 700 }}>Borrower</small>
                  <h5 className="mt-1 mb-1" style={{ fontWeight: 800, color: "#0f172a", fontSize: 15 }}>{selectedStudent.name}</h5>
                  <div style={{ fontSize: 12, color: "#475569" }} className="mb-2">Code: <strong style={{ color: "#0f172a" }}>{selectedStudent.code}</strong></div>
                  <Badge variant="info" style={{ padding: "4px 8px", background: "#e0f2fe", color: "#0369a1", fontWeight: 700, fontSize: 10 }}>
                    {selectedStudent.type}
                  </Badge>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Main Panel: Loans Table Grid */}
          <Col lg={9} className="mb-4">
            <Card className="border-0 shadow-sm" style={{ borderRadius: 12 }}>
              <Card.Header style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0", padding: "14px 18px" }}>
                <h6 className="mb-0" style={{ fontWeight: 800, color: "#1e293b" }}>Patron Circulation Ledger — Active Loans</h6>
              </Card.Header>
              <Card.Body className="p-3">
                {loadingLoans ? (
                  <div className="text-center py-4"><Spinner animation="border" size="sm" /></div>
                ) : activeLoans.length === 0 ? (
                  <div className="text-center p-5 text-muted bg-light rounded" style={{ borderRadius: 10 }}>
                    <i className="fal fa-check-circle fa-3x d-block mb-3 text-success" />
                    <p style={{ fontWeight: 700, margin: 0 }}>All Checked Items Returned</p>
                    <small className="text-muted">This patron has no pending checked out books.</small>
                  </div>
                ) : (
                  <Table responsive borderless className="align-middle mb-0" style={{ fontSize: 13 }}>
                    <thead>
                      <tr className="border-bottom text-muted" style={{ fontWeight: 700, fontSize: 11 }}>
                        <th style={{ width: 40, paddingLeft: 12 }}>
                          <Form.Check
                            type="checkbox"
                            checked={selectedLoans.length === activeLoans.length}
                            onChange={this.selectAllLoans}
                            style={{ cursor: "pointer" }}
                          />
                        </th>
                        <th>ACCESSION & TITLE</th>
                        <th>SCHEME</th>
                        <th>ISSUE DATE</th>
                        <th>DUE DATE</th>
                        <th>OVERDUE FINES</th>
                        <th className="text-end" style={{ paddingRight: 12 }}>ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {activeLoans.map((loan) => {
                        const isOverdue = new Date(loan.due_date) < new Date();
                        const isChecked = selectedLoans.some(l => l.id === loan.id);
                        return (
                          <tr key={loan.id} className="border-bottom hover-row" style={{ background: isChecked ? "#f9fafb" : "transparent" }}>
                            <td style={{ paddingLeft: 12 }}>
                              <Form.Check
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => this.toggleLoanSelection(loan)}
                                style={{ cursor: "pointer" }}
                              />
                            </td>
                            <td>
                              <div style={{ fontWeight: 700, color: "#1e293b" }}>{loan.book_title}</div>
                              <small className="text-muted" style={{ fontSize: 11 }}>
                                Acc No: <strong style={{ color: "#334155" }}>{loan.accession_no}</strong> {loan.rack_location ? `| Shelf: ${loan.rack_location}` : ""}
                              </small>
                            </td>
                            <td>
                              <Badge
                                variant={loan.loan_type === "Book Bank" ? "warning" : "info"}
                                style={{
                                  fontSize: 10,
                                  background: loan.loan_type === "Book Bank" ? "#fef3c7" : "#e0f2fe",
                                  color: loan.loan_type === "Book Bank" ? "#d97706" : "#0284c7",
                                  padding: "4px 8px"
                                }}
                              >
                                {loan.loan_type === "Book Bank" ? "Book Bank" : "Standard"}
                              </Badge>
                            </td>
                            <td className="text-muted">{loan.issue_date}</td>
                            <td>
                              <span style={{ 
                                fontWeight: 700, 
                                color: isOverdue ? "#ef4444" : "#1e293b"
                              }}>
                                {loan.due_date}
                              </span>
                              {isOverdue && (
                                <Badge variant="danger" className="ms-2" style={{ background: "#fee2e2", color: "#ef4444", fontSize: 9, marginLeft: 6 }}>
                                  Overdue
                                </Badge>
                              )}
                            </td>
                            <td>
                              {loan.fine_amount > 0 ? (
                                <Badge variant="danger" style={{ background: "#fee2e2", color: "#ef4444", fontWeight: 800, padding: "4px 6px" }}>
                                  {this.formatCurrency(loan.fine_amount)}
                                </Badge>
                              ) : (
                                <span className="text-success" style={{ fontSize: 12 }}>None</span>
                              )}
                            </td>
                            <td className="text-end" style={{ paddingRight: 12 }}>
                              <div className="d-flex justify-content-end gap-1" style={{ gap: 6 }}>
                                <Button
                                  variant="light"
                                  size="sm"
                                  onClick={() => this.handleRenew(loan.id)}
                                  disabled={loan.status === "lost" || loan.status === "damaged"}
                                  style={{ color: "#4f46e5", background: "#f5f3ff", border: "none", fontWeight: 700, fontSize: 11, height: 28, padding: "0 10px" }}
                                >
                                  Renew
                                </Button>
                                <Button
                                  variant="primary"
                                  size="sm"
                                  onClick={() => this.openReturnModal(loan)}
                                  style={{ background: "#10b981", border: "none", fontWeight: 700, fontSize: 11, height: 28, padding: "0 10px" }}
                                >
                                  Return
                                </Button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* BATCH RETURN SUMMARY DOCK */}
        {selectedStudent && selectedLoans.length > 0 && (
          <div 
            style={{
              position: "fixed",
              bottom: 24,
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 1000,
              background: "#1e293b",
              color: "#fff",
              borderRadius: 12,
              boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3)",
              padding: "12px 24px",
              width: "calc(100% - 48px)",
              maxWidth: 680,
              display: "flex",
              justifyContent: "between",
              alignItems: "center",
              gap: "16px",
              border: "1px solid #334155"
            }}
            className="d-flex justify-content-between align-items-center"
          >
            <div>
              <div style={{ fontWeight: 800, fontSize: 14 }}>Selected {selectedLoans.length} items for return</div>
              <small style={{ color: "#94a3b8" }}>
                Total Fines Pending: <strong style={{ color: "#f87171" }}>{this.formatCurrency(totalBatchFines)}</strong>
              </small>
            </div>
            <div className="d-flex align-items-center" style={{ gap: 8 }}>
              <Button 
                variant="outline-light" 
                size="sm" 
                onClick={() => this.setState({ selectedLoans: [] })} 
                style={{ fontWeight: 700, borderRadius: 6, borderColor: "#475569", color: "#cbd5e1", fontSize: 12 }}
              >
                Cancel
              </Button>
              <Button 
                variant="success" 
                size="sm" 
                onClick={this.openBatchReturnModal} 
                style={{ fontWeight: 800, borderRadius: 6, background: "#10b981", border: "none", padding: "6px 14px", fontSize: 12 }}
              >
                Return Selection &rarr;
              </Button>
            </div>
          </div>
        )}

        {/* SINGLE RETURN MODAL */}
        <Modal show={showReturnModal} onHide={() => this.setState({ showReturnModal: false, selectedLoan: null })} centered>
          {selectedLoan && (
            <Form onSubmit={this.handleReturnSubmit}>
              <Modal.Header closeButton style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                <Modal.Title style={{ fontSize: 15, fontWeight: 800 }}>
                  Process Return: {selectedLoan.book_title}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ padding: "20px" }}>
                <div className="p-3 border rounded mb-3 bg-light" style={{ fontSize: 12, borderRadius: 8 }}>
                  <div className="mb-1">Accession No: <strong>{selectedLoan.accession_no}</strong> {selectedLoan.rack_location ? `(Shelf: ${selectedLoan.rack_location})` : ""}</div>
                  <div className="mb-1">Borrower: <strong>{selectedLoan.borrower_name}</strong> ({selectedLoan.borrower_type})</div>
                  <div className="mb-1">Due Date: <strong className={new Date(selectedLoan.due_date) < new Date() ? "text-danger" : ""}>{selectedLoan.due_date}</strong></div>
                  <div>Accumulated Late Fee: <strong className="text-danger">{this.formatCurrency(selectedLoan.fine_amount)}</strong></div>
                </div>

                <Form.Group className="mb-3">
                  <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }} className="text-uppercase">Condition of Returned Book *</Form.Label>
                  <Form.Control
                    as="select"
                    name="copyStatusOnReturn"
                    value={copyStatusOnReturn}
                    onChange={this.handleFieldChange}
                    style={{ fontSize: 13, height: 38 }}
                  >
                    <option value="available">Perfect / Normal (Return to inventory)</option>
                    <option value="damaged">Damaged Book (Requires repair fee)</option>
                    <option value="lost">Lost Book (Requires replacement cost)</option>
                  </Form.Control>
                </Form.Group>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }} className="text-uppercase">Fine Charge Type</Form.Label>
                      <Form.Control
                        type="text"
                        name="customFineType"
                        value={customFineType}
                        onChange={this.handleFieldChange}
                        disabled={copyStatusOnReturn === "available"}
                        style={{ fontSize: 13, height: 38 }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }} className="text-uppercase">Fine Amount (INR)</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        min="0"
                        name="customFineAmount"
                        value={customFineAmount}
                        onChange={this.handleNumberChange}
                        disabled={copyStatusOnReturn === "available"}
                        style={{ fontSize: 13, height: 38 }}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-0">
                  <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }} className="text-uppercase">Amount Paid Today (INR) *</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    min="0"
                    max={customFineAmount}
                    name="paidAmount"
                    value={paidAmount}
                    onChange={this.handleNumberChange}
                    required
                    style={{ fontSize: 13, height: 38 }}
                  />
                  <small className="text-muted">Remaining balance: {this.formatCurrency(Math.max(0.0, customFineAmount - paidAmount))}</small>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer style={{ background: "#f8fafc", borderTop: "1px solid #e2e8f0" }}>
                <Button variant="light" size="sm" onClick={() => this.setState({ showReturnModal: false, selectedLoan: null })} style={{ fontWeight: 600 }}>
                  Cancel
                </Button>
                <Button type="submit" size="sm" disabled={returning} style={{ background: "#10b981", border: "none", fontWeight: 700 }}>
                  {returning ? "Processing..." : "Complete Return"}
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Modal>

        {/* BATCH RETURN MODAL */}
        <Modal show={showBatchModal} onHide={() => this.setState({ showBatchModal: false })} size="lg" centered>
          <Form onSubmit={this.handleBatchReturnSubmit}>
            <Modal.Header closeButton style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
              <Modal.Title style={{ fontSize: 15, fontWeight: 800 }}>
                Batch Process Returns ({selectedLoans.length} Books)
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: "20px" }}>
              {selectedStudent && (
                <div className="mb-3" style={{ fontSize: 12 }}>
                  Borrower: <strong>{selectedStudent.name}</strong> ({selectedStudent.type} | Code: {selectedStudent.code})
                </div>
              )}

              <Table responsive borderless className="align-middle mb-0" style={{ fontSize: 12 }}>
                <thead>
                  <tr className="border-bottom text-muted" style={{ fontWeight: 700, fontSize: 11 }}>
                    <th style={{ padding: "8px 0" }}>BOOK DETAILS</th>
                    <th>CONDITION *</th>
                    <th style={{ width: 140 }}>FINE TYPE</th>
                    <th style={{ width: 110 }}>FINE AMOUNT</th>
                    <th style={{ width: 110 }}>PAID AMOUNT</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedLoans.map((loan) => {
                    const item = batchReturnsData[loan.id];
                    if (!item) return null;
                    return (
                      <tr key={loan.id} className="border-bottom">
                        <td style={{ padding: "12px 0", maxWidth: 220 }}>
                          <div style={{ fontWeight: 700, color: "#1e293b" }}>{loan.book_title}</div>
                          <small className="text-muted">Acc No: {loan.accession_no}</small>
                        </td>
                        <td>
                          <Form.Control
                            as="select"
                            value={item.status}
                            onChange={(e) => this.handleBatchConditionChange(loan.id, e.target.value)}
                            style={{ fontSize: 12, height: 32, padding: "0 6px" }}
                          >
                            <option value="available">Perfect / Normal</option>
                            <option value="damaged">Damaged Book</option>
                            <option value="lost">Lost Book</option>
                          </Form.Control>
                        </td>
                        <td>
                          <Form.Control
                            type="text"
                            value={item.customFineType}
                            onChange={(e) => {
                              const updated = { ...item, customFineType: e.target.value };
                              this.setState({ batchReturnsData: { ...batchReturnsData, [loan.id]: updated } });
                            }}
                            disabled={item.status === "available"}
                            style={{ fontSize: 12, height: 32, padding: "4px 8px" }}
                          />
                        </td>
                        <td>
                          <Form.Control
                            type="number"
                            step="0.01"
                            min="0"
                            value={item.customFineAmount}
                            onChange={(e) => this.handleBatchNumberChange(loan.id, "customFineAmount", e.target.value)}
                            disabled={item.status === "available"}
                            style={{ fontSize: 12, height: 32, padding: "4px 8px" }}
                          />
                        </td>
                        <td>
                          <Form.Control
                            type="number"
                            step="0.01"
                            min="0"
                            max={item.customFineAmount}
                            value={item.paid_amount}
                            onChange={(e) => this.handleBatchNumberChange(loan.id, "paid_amount", e.target.value)}
                            required
                            style={{ fontSize: 12, height: 32, padding: "4px 8px" }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer style={{ background: "#f8fafc", borderTop: "1px solid #e2e8f0" }}>
              <Button variant="light" size="sm" onClick={() => this.setState({ showBatchModal: false })} style={{ fontWeight: 600 }}>
                Cancel
              </Button>
              <Button type="submit" size="sm" disabled={returning} style={{ background: "#10b981", border: "none", fontWeight: 800 }}>
                {returning ? "Processing Batch..." : "Submit Batch"}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default ReturnBook;
